import { Button, Card, Elevation, FormGroup, InputGroup } from "@blueprintjs/core";
import { Link } from 'react-router-dom';
import { DateInput, TimePicker } from "@blueprintjs/datetime";
import React, { Fragment } from 'react';
import dateUtils from '../../../utils/date';
import flatProfile from '../../assets/flatProfile.png';
import flatProfileTrans from '../../assets/flatProfileTrans.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import fetch from "node-fetch";
import numberUtils from "../../../utils/number";
import Sugar from "sugar";

const jsDateFormatter = {
  // note that the native implementation of Date functions differs between browsers
  formatDate: date => date.toLocaleDateString(),
  parseDate: str => new Date(str),
  showActionsBar: true,
  placeholder: "M/D/YYYY",
};

class VisitProperty extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      data: [],
      values: { timeInput: dateUtils.timeFormat(this.getTime(17)) },
      formError: {
        name: false,
        mobile: false,
        date: false,
        otp: false,
      },
      loadToggle: false,
      otp: false,
      complete: false,
    }
  }

  getTime = (hours, min) => {
    min = min || 0;
    const date = new Date();
    date.setHours(hours, min);
    return date;
  }

  handleClick = () => {
    (this.state.values.nameInput ? this.formErrorValueChange("name", false) : this.formErrorValueChange("name", true));
    (this.state.values.mobileInput ? this.formErrorValueChange("mobile", false) : this.formErrorValueChange("mobile", true));
    (this.state.values.dateInput ? this.formErrorValueChange("date", false) : this.formErrorValueChange("date", true));

    if (!this.state.formError.name && !this.state.formError.mobile && !this.state.formError.date) {
      if (this.state.values.mobileInput) {
      }
      let URL = `/v2/send-otp`;
      fetch(URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({ mobile: this.state.values.mobileInput, action: "leadImpression" })
      })
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          if (result.message === 'Ok') {
            this.setState({ otp: true });
          }
        });
    };
  }

  handleClick2 = () => {
    (this.state.values.OTPInput ? this.formErrorValueChange("otp", false) : this.formErrorValueChange("otp", true))
    if (!this.state.formError.otp) {
      this.setState({ loadToggle: true })
    }
    let URL = `/v2/lead-impression/create`;
    let data = {
      inventoryUid: `${this.props.match.params.id}`,
      name: this.state.values.nameInput,
      mobile: this.state.values.mobileInput,
      visitAt: `${this.state.values.dateInput} ${this.state.values.timeInput}`,
      otp: this.state.values.OTPInput
    }
    fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(data)
    })
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.message === 'Ok') {
          this.setState({ complete: true, loadToggle: false });
        }
      });
  }

  formErrorValueChange = (field, flag) => {
    let errors = this.state.formError;
    errors[field] = flag;
    this.setState({ errors });
  }

  textInputChange = (event) => {
    let values = this.state.values;
    values[event.target.id] = event.target.value;
    this.setState({ values });
  }

  dateInputChange = (value, id) => {
    let values = this.state.values;
    values[id] = dateUtils.dateFormat(value);
    this.setState({ values });
  }

  timeInputChange = (value, id) => {
    let values = this.state.values;
    values[id] = dateUtils.timeFormat(value);
    // this.setState({ values });
  }

  componentDidMount() {
    let URL = `/v1/property/inventory/detail-with-property?uid=${this.props.match.params.id}`;
    fetch(URL)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.message === 'Ok') {
          this.setState({
            data: result.data,
            loaded: true,
          });
        }
      });
  }

  render() {
    let inventoryType = this.state.data.inventoryType;
    if (inventoryType === 'Sell') {
      inventoryType = 'Sale'
    }
    let imgSrc = flatProfile;
    if (this.state.data.property && this.state.data.property.photos && this.state.data.property.photos.length) {
      imgSrc = this.state.data.property.photos[0].url || flatProfileTrans;
    }
    return (
      <section className="section">
        {this.state.loaded ?
          <div className="container">
            <div className="w-720">
              <Card className="card visit-prop-card" elevation={Elevation.ONE}>
                <div className="columns is-mobile is-multiline">
                  <div className="column is-narrow">
                    <img src={imgSrc} alt="" className="prop-img" />
                  </div>
                  <div className="column">
                    <Link to={`/viewproperty/${this.state.data.uid}`}>
                      <div className="property-details-name">
                        <strong>{this.state.data.bedroomCount}BHK for {this.state.data.inventoryType}</strong>
                        <br />
                        {this.state.data.property.society ?
                          this.state.data.property.society.name : null}
                      </div>
                    </Link>
                  </div>
                  <div className="column is-12-mobile is-narrow-desktop">
                    <strong>{inventoryType === 'Sale' ? numberUtils.intoReadableAmount(this.state.data.sellPrice) : numberUtils.intoReadableAmount(this.state.data.leaseMonthlyRentAmount)}</strong>
                    <br />
                    {this.state.data.isNegotiable ? '(Negotiable)' : null}
                  </div>
                </div>
              </Card>
            </div>

            <div className="w-420">
              {
                this.state.complete ?
                  <Card className="card" elevation={Elevation.ONE}>
                    <div className="visit-summary content is-size-6">
                      <p className="has-text-success has-text-centered" style={{ marginBottom: "2rem" }}>
                        Congratulations!<br />
                        Your visit request has been accepted successfully.<br />
                        Our representative will contact you and confirm your visit
                      </p>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="visit-summary-title">Name :</div>
                        </div>
                        <div className="column">
                          <p>{this.state.values.nameInput}</p>
                        </div>
                      </div>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="visit-summary-title">Mobile :</div>
                        </div>
                        <div className="column">
                          <p>{this.state.values.mobileInput}</p>
                        </div>
                      </div>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="visit-summary-title">Date :</div>
                        </div>
                        <div className="column">
                          <p>{Sugar.Date.format(new Date(this.state.values.dateInput), '{dd}-{Mon}-{yyyy}')}</p>
                        </div>
                      </div>
                      <div className="columns is-mobile">
                        <div className="column is-narrow">
                          <div className="visit-summary-title">Time :</div>
                        </div>
                        <div className="column">
                          <p>{this.state.values.timeInput}</p>
                        </div>
                      </div>
                    </div>
                  </Card>
                  :
                  <Fragment>
                    {
                      this.state.loadToggle ?
                        <div className="has-text-centered has-text-grey-light search-loader">
                          <FontAwesomeIcon icon={faCircleNotch} spin size="4x" />
                        </div> :
                        <div>
                          <Card className="card" elevation={Elevation.ONE}>
                            <FormGroup
                              helperText={this.state.formError.name && "This field is required"}
                              intent="warning"
                            >
                              <InputGroup onChange={this.textInputChange} large id="nameInput" placeholder="Name" type="text" />
                            </FormGroup>
                            <FormGroup
                              helperText={this.state.formError.mobile && "This field is required"}
                              intent="warning"
                            >
                              <InputGroup onChange={this.textInputChange} large id="mobileInput" placeholder="Mobile" type="number" />
                            </FormGroup>
                            <div className="columns is-v-centered mobile-columns">
                              <div className="column is-6 col-thin-ex">
                                <FormGroup classname="full-input"
                                  helperText={this.state.formError.date && "This field is required"}
                                  intent="warning"
                                >
                                  <DateInput id="dateInput" onChange={(value) => this.dateInputChange(value, "dateInput")} inputProps={{ large: true }} {...jsDateFormatter} />
                                </FormGroup>
                              </div>
                              <div className="column is-6 col-thin-ex">
                                <FormGroup>
                                  <TimePicker id="timeInput"
                                    useAmPm
                                    minTime={this.getTime(5)}
                                    defaultValue={this.getTime(17)}
                                    className="bp3-timepicker-large"
                                    onChange={(value) => this.timeInputChange(value, "timeInput")}
                                  />
                                </FormGroup>
                              </div>
                            </div>
                            {
                              this.state.otp &&
                              <Fragment>
                                <hr />
                                <p className="is-size-6">OTP is sent to your mobile number</p>
                                <FormGroup
                                  helperText={this.state.formError.otp && "This field is required"}
                                  intent="warning"
                                >
                                  <InputGroup onChange={this.textInputChange} large id="OTPInput" placeholder="OTP" />
                                </FormGroup>
                              </Fragment>
                            }
                          </Card>
                          <div className="section-thin">
                            {
                              this.state.otp ?
                                <div>
                                  <Button
                                    text="Verify OTP"
                                    onClick={this.handleClick2}
                                    fill
                                    large
                                  />
                                </div>
                                :
                                <div>
                                  <Button
                                    text="Submit"
                                    onClick={this.handleClick}
                                    fill
                                    large
                                  />
                                </div>
                            }
                          </div>
                        </div>
                    }
                  </Fragment>
              }
            </div>
          </div>
          :
          null
        }
      </section>
    );
  }
}

export default VisitProperty;


// WEBPACK FOOTER //
// ./src/app/components/visit-property/index.js